import { reducer } from './modules';

export { default as townActions } from './modules';
export { default as townSaga } from './sagas';
export { default as townSelectors } from './selectors';
export { default as townOperations } from './operations';

export default reducer;
